// extracted by mini-css-extract-plugin
export default {"overlay":"xB-z","bodyOpen":"yB-z","content":"zB-z","header":"AB-z","close":"BB-z","closeNoHeading":"CB-z"};